var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var Installation = /** @class */ (function (_super) {
    __extends(Installation, _super);
    function Installation(props) {
        return _super.call(this, props) || this;
    }
    Installation.prototype.render = function () {
        return (React.createElement("section", { className: "content3", id: "3" },
            React.createElement("h3", null, "Quality and Safety go Hand-In-Hand."),
            React.createElement("p", null,
                "InstallerNet\u2019s vast network of professional installers are trained and certified to install your WeatherFlow Tempest Sensor and come with industry-leading labor warranties on top of your product warranty.",
                React.createElement("br", null),
                React.createElement("br", null),
                "Proper installation of your smart weather sensor is as important as the system itself to guarantee everything is functioning smoothly. Not only will you receive excellent service and quality installation, our installation labor comes with a lifetime warranty."),
            React.createElement("div", { className: "contentThird" },
                React.createElement("img", { alt: "Service Tech", className: "imgC", src: "img/service-tech2.png" }),
                React.createElement("div", { className: "infoBox" },
                    React.createElement("p", { className: "boxHeading" }, "Professional Installation"),
                    React.createElement("p", null, "All of our installation professionals will use only approved standards, authorized parts and procedures in the completion of your installation."))),
            React.createElement("div", { className: "contentThird" },
                React.createElement("img", { alt: "Lifetime Warranty", className: "imgC", src: "img/warranty-starburst.png" }),
                React.createElement("div", { className: "infoBox" },
                    React.createElement("p", { className: "boxHeading" }, "Labor Warranty"),
                    React.createElement("p", null, "Not only will you receive excellent service and quality installation, our installation labor comes with a lifetime warranty."))),
            React.createElement("div", { className: "contentThird" },
                React.createElement("img", { alt: "Service Rep", className: "imgC", src: "img/service-rep.jpg" }),
                React.createElement("div", { className: "infoBox" },
                    React.createElement("p", { className: "boxHeading" }, "Customer Service"),
                    React.createElement("p", null, "Our Customer Service Department is available to assist with any installation inquiries Mon.-Fri. 9am-6pm EST."))),
            React.createElement("div", { className: "clearFix" }),
            React.createElement("div", { className: "arrowBox" })));
    };
    return Installation;
}(Component));
export default Installation;
